import request from '@/utils/request/index';
import { RecordParams } from './model/recordModel';

/**
 * @description 获取默认档案
 */
export function getDefaultRecord() {
  return request({
    url: '/dt/portal/archive/v1/default',
    method: 'get',
  });
}

/**
 * @description 获取全部档案
 */
export function getAllRecord() {
  return request({
    url: '/dt/portal/archive/v1',
    method: 'get',
  });
}
/**
 * @description 获取指定档案
 */
export function getRecordById(archiveId: number) {
  return request({
    url: `/dt/portal/archive/v1/profile/${archiveId}`,
    method: 'get',
  });
}
/**
 * @description 新建档案
 */
export function createRecord(data: RecordParams) {
  return request({
    url: '/dt/portal/archive/v1',
    method: 'post',
    data,
  });
}
/**
 * @description 修改档案
 */
export function editRecord(data: RecordParams) {
  return request({
    url: `/dt/portal/archive/v1/edit/${data.archiveId}`,
    method: 'put',
    data,
  });
}
